
export const formatDateTimeWithAt = (input) => {
  // Parse the input string into a Date object
  const date = new Date(input);
  
  // Check if the date is valid
  if (isNaN(date)) return input; // fallback: return original input if invalid

  // Format using Intl.DateTimeFormat
  const formatted = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);

  // Replace the comma with ' at '
  return formatted.replace(',', ' at');
}